export default __webpack_public_path__ + "static/articles-psoriazal-plus-kak-da-se-spravim-b829d60fe65fca9a9b3475682beb38ea.jpg";